import CountDown from './CountDown';

// init counter
new CountDown();
